export enum FiscalType {
  IP = 1,
  LLC = 2,
  JSC = 3,
  PJSC = 4,
  CJSC = 5,
  LLP = 6,
  OsOO = 7,
}

export enum SoleTraderType {
  OldStyle = 1,
  NewStyle = 2,
}
